// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer>
      <div className="container">
        <div className="footer-top">
          <div className="footer-brand">
            <img src="/assets/logo.svg" alt="LEAPS" className="footer-logo" />
            <p className="footer-company">株式会社LEAPS</p>
            <p className="footer-address">
              〒101-0051
              <br />
              東京都千代田区神田神保町1-41
            </p>
          </div>
          <div className="footer-map">
            <div>
              <h3>サービス</h3>
              <Link to="/services">サービス一覧</Link>
              <Link to="/services/ai-integration">AIインテグレーション</Link>
              <Link to="/services/blockchain">ブロックチェーン事業開発</Link>
            </div>
            <div>
              <h3>LEAPSについて</h3>
              <Link to="/cases">実績</Link>
              <Link to="/news">お知らせ</Link>
              <a href="https://leaps-inc.com/media/">LEAPS AI Media ↗</a>
              <Link to="/company">会社概要</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <small>© LEAPS Inc.</small>
          <Link to="/privacy">プライバシーポリシー</Link>
        </div>
      </div>
    </footer>
  );
}
